module.exports = __webpack_public_path__ + "img/红螺寺.8a8ddc1d.png";